import { STATIC_DOMAINS } from 'mk/settings';
import { PhotoEntity, PhotoMimetype } from 'mk2/schemas';

// keep in sync with system/utils.py
const PHOTO_CODE_CHAR_COUNT = 11;

function getDomain(code) {
    const isDevPhotoCode = code.length > PHOTO_CODE_CHAR_COUNT && code.startsWith('dev');
    const section = !isDevPhotoCode ? 's3' : 's3dev';
    const domains = STATIC_DOMAINS[section];
    const num = code.charCodeAt(code.length - 1);
    const idx = num % domains.length;

    return domains[idx];
}

export function photoUrl(photo: PhotoEntity, version: string) {
    const domain = getDomain(photo.code);
    const extension = {
        [PhotoMimetype.JPEG]: 'jpg',
        [PhotoMimetype.PNG]: 'png',
        [PhotoMimetype.GIF]: 'gif',
    }[photo.mimetype];
    return `https://${domain}/${photo.code}_${version}.${extension}`;
}
